exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".referral-program-table__operation {\n  margin-left: 8px;\n}\n", ""]);

// exports
